/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_SearchInputs */

const es_sidebar_search = /** @type {(inputs: Sidebar_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar Chats...`)
};

const en_sidebar_search = /** @type {(inputs: Sidebar_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Chats...`)
};

/**
* | output |
* | --- |
* | "Search Chats..." |
*
* @param {Sidebar_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_search = /** @type {((inputs?: Sidebar_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_search(inputs)
	return en_sidebar_search(inputs)
});
export { sidebar_search as "sidebar.search" }